// extracted by mini-css-extract-plugin
module.exports = {"grid":"ArtistIndexOverviews-grid-2QWo9"};